import { classNames } from '@utils/class-names';
import { roundIconStyles } from '@utils/constants';
import React from 'react';
export const Counter = ({ filled = false, children }) => {
    return (React.createElement("div", { className: classNames('border border-darkBlue/30', children.toString().length <= 3 ? 'text-xs' : 'text-[8px]', filled && 'bg-darkBlue text-white', roundIconStyles), "data-testid": "Counter" }, children));
};
